import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DownloadControlsWrapper = styled<any, any>(
    'div',
    'downloadControlsWrapper',
    'documentsGridActions'
)`
    ${propStyles};
    display: inline-flex;
    align-items: center;
`;

DownloadControlsWrapper.defaultProps = {};

export default DownloadControlsWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGridActions/StyledComponents/DownloadControlsWrapper.tsx